import { render, staticRenderFns } from "./DescriptionTitle.vue?vue&type=template&id=6d49aae4&scoped=true"
import script from "./DescriptionTitle.vue?vue&type=script&lang=js"
export * from "./DescriptionTitle.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTitle.vue?vue&type=style&index=0&id=6d49aae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d49aae4",
  null
  
)

export default component.exports